<template>
  <div class="form">
    <input
      v-bind="$attrs"
      v-model="model"
      :type="inputType"
      :class="{'is-invalid': error}"
      :disabled="disabled"
      ref="input"
      class="form-control"
      @keydown.enter.stop.prevent="onEnter"
      @blur.stop.prevent="onBlur"
      @input="onInput"
    >
    <span class="field-icon"
          :class="{'error': error,'password': isPassword, 'visible-password': passwordIsVisible}"
    >
        <img src="../../assets/img/show-password-icon.png" alt=""
             class="toggle-password-visibility-icon"
             v-show="isPassword"
             @click="togglePasswordVisibility"
        >
    </span>
    <small class="text-danger" v-show="error">{{ $t(error) }}</small>
  </div>
</template>

<script>
import {DOM_INPUT_TYPES} from '@/const';

export default {
  name: 'BaseInput',
  inheritAttrs: false,
  data() {
    return {
      passwordIsVisible: false,
    };
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    error: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        const trimmed = typeof val === 'string' ? val.trim() : val;
        this.$emit('input', trimmed);
      },
    },
    isPassword() {
      return this.type === DOM_INPUT_TYPES.PASSWORD;
    },
    inputType() {
      if (!this.isPassword) return this.type;
      return this.passwordIsVisible? DOM_INPUT_TYPES.TEXT : DOM_INPUT_TYPES.PASSWORD;
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordIsVisible = !this.passwordIsVisible;
      this.$refs.input.focus();
    },
    onEnter(e) {
      this.$emit('enter', e);
    },
    onBlur() {
      this.$emit('blur', this.model);
    },
    onInput(e) {
      if (e.type === 'input' && !(e instanceof InputEvent) || e.inputType === 'insertFromPaste') {
        this.$nextTick(this.onAutoFill);
      }
    },
    onAutoFill() {
      this.$emit('blur', this.model);
    },
    focus() {
      this.$refs.input.focus();
    },
  },
  mounted() {
    this.$emit('interface', {
      focus: this.focus,
      blur: this.onBlur,
    });
  },
  beforeDestroy() {
    this.$emit('interface', null);
  },
};
</script>

<style lang="scss" scoped>
.icon {
  pointer-events: all !important;
}

span {
  &.visible-password {
    .toggle-password-visibility-icon {
      opacity: 1;
    }
  }

  .toggle-password-visibility-icon {
    cursor: pointer;
    opacity: 0.5;
  }
}

.help {
  text-align: left;
  margin-top: 0;
}

.is-invalid {
  margin-bottom: 0;
  background-image: none;

}

.field-icon {
  float: right;
  margin-right: 5px;
  margin-top: -32px;
  position: relative;
  z-index: 2;
}
</style>
